<template>
    <div class="TransferOwnershipComponent">

        <b-form autocomplete="off">

            <b-form-group id="input-group-Users" :label="lang.label_Users + ':'" label-for="input-2">
                <b-form-select v-model="selectedUser" :options="usersList" size="sm" class="mt-3">
                </b-form-select>

            </b-form-group>

            



        </b-form>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'


export default {
    name: "TransferOwnershipComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {

            selectedUser: null,
            usersList: [
                {
                    value: null,
                    text: "Choose a user..."
                }
            ],
            reason: ""
        }
    },
    computed: {
        ...mapGetters({

            currentUser: 'currentUser'

        }),
        isDelegate() {
            return this.lang.label_Users != undefined;
        }
    },
    created() {
        let vue = this;


        this.$store.dispatch('u_getUsersBasic')
            .then((result) => {
                console.log(result.data)


                if (result.status == "OK") {
                    vue.createUsersList(result.data);


                } else {

                }

            })

    },
    updated() {

        const form = {

            userId: this.selectedUser,
           
        }


        this.$store.dispatch("transferOwnershipForm", form)

    },
    methods: {
        createUsersList(data) {

            for (let i = 0, lei = data.length; i < lei; i++) {
                
                if (data[i].Role != 'Reader') {
                    const obj = {
                        value: data[i].userId,
                        text: data[i].FirstName + " " + data[i].LastName
                    }
                    this.usersList.push(obj);
                }

            }

        }
    }
}
</script>
<style lang="scss">
.TransferOwnershipComponent {}
</style>



// WEBPACK FOOTER //
// src/components/shared/TransferOwnershipComponent.vue